<template>
  <div ref="formRef" class="flex flex-wrap diygw-col-24 top-flex-clz">
    <div class="flex flex-wrap justify-end top-flex1-clz">
      <div class="flex flex-wrap diygw-col-12 top-flex1-clz-1">
        <div class="diygw-col-12 top-text7-clz">
          <div style="line-height: 1" class="index-banner-btn">DEEP<br>TALENTING</div>
        </div>
<!--        <div class="diygw-col-12 top-text7-clz">-->
<!--          <div style="line-height: 1" class="index-banner-btn ani wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.2s">DEEP<br>TALENTING</div>-->
<!--        </div>-->
      </div>
      <a class="top-text-clz" href="javascript:void(0);" @click="redrect2Url('home')" :class="homeActive">首页</a>
      <a class="top-text-clz" href="javascript:void(0);" @click="redrect2Url('serve')"  :class="serveActive">服务</a>
      <a class="top-text-clz" href="javascript:void(0);" @click="redrect2Url('dcha')"  :class="dchaActive" >洞察</a>
      <a class="top-text-clz" href="javascript:void(0);" @click="redrect2Url('contact')" :class="contactActive" >成为客户</a>
    </div>
    <div class="flex flex-wrap diygw-col-6 justify-center top-flex2-clz">
      <img :src='this.$store.state.crmURL + "/dt/logo1.png"' class="image-size" />
    </div>
  </div>
</template>

<script>
import {getCategory, getCategoryCourse, getCourseList} from "../../api/course";
export default {
  components: {},
    data(){
      return{
        mobile: false,
        homeActive: "",
        serveActive: "",
        dchaActive: "",
        contactActive: "",
      }
    },
    created() {

    },
    mounted() {
      // var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      // if (currentScroll > 0) {
      //   window.scrollTo(0, currentScroll - currentScroll / 6);
      // }
      let that = this;
      this.$nextTick(()=> {
        if(that.$refs.formRef.offsetWidth < 900){
          this.mobile = false;
          this.$store.state.mobile = false;
        }else{
          this.mobile = true;
          this.$store.state.mobile = true;
        }
      });
      // let _self = this;
      // document.addEventListener('click', (e) => {
      //   _self.showResult = false;
      // })
    },
    computed: {

    },
    watch: {
      '$route'(to, from) {
        let path = to.path;
        this.homeActive = "";
        this.serveActive = "";
        this.dchaActive = "";
        this.contactActive = "";
        if (path == "/home") {
          this.homeActive = "active";
        } else if (path == "/serve") {
          this.serveActive = "active";
        } else if (path == "/dcha") {
          this.dchaActive = "active";
        } else if (path == "/contact") {
          this.contactActive = "active";
        }
      }
    },
    methods:{
      redrect2Url(path) {
        this.$router.push('/' + path);
        this.homeActive = "";
        this.serveActive = "";
        this.dchaActive = "";
        this.contactActive = "";
        if (path == "home") {
          this.homeActive = "active";
        } else if (path == "serve") {
          this.serveActive = "active";
        } else if (path == "dcha") {
          this.dchaActive = "active";
        } else if (path == "contact") {
          this.contactActive = "active";
        }
      }
    },
  }
</script>

<style>
  .top-flex1-clz-1 {
    padding-left: 70px;
  }
  .image-size {
    width: 173px;
    height: 120px;
  }
  .top-flex-clz {
    background-color: #e83928;
  }
  .top-flex-clz .active {
    color: #3e3a39;
  }
  .top-flex1-clz {
    margin-left: 5px;
    padding-top: 5px;
    padding-left: 5px;
    width: calc(75% - 5px - 5px);
    padding-bottom: 5px;
    margin-top: 25px;
    margin-bottom: 25px;
    margin-right: 5px;
    padding-right: 10px;
  }
  .top-text7-clz {
    padding-top: 5px;
    color: #ffffff;
    font-weight: bold;
    padding-left: 5px;
    font-size: 20px !important;
    padding-bottom: 5px;
    padding-right: 5px;
  }
  .top-text-clz {
    padding-top: 5px !important;
    color: #ffffff;
    padding-left: 5px !important;
    font-weight: bold !important;
    font-size: 18px !important;
    width: 12.5%;
    padding-bottom: 5px !important;
    line-height: 2.5 !important;
    text-align: center !important;
    padding-right: 5px !important;
  }
  @media screen and (max-width: 900px) {
    .top-flex1-clz {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
    .top-flex1-clz-1 {
      display: none !important;
    }
    .top-flex2-clz {
      display: none !important;
    }
    .top-text-clz {
      width: 25% !important;
      font-size: 14px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderTop/HeaderTop.vue